import * as React from "react";
import * as ReactDOM from "react-dom";
import { BlockRowInputTooltipDisposer, BlockRowInputLabel } from './BlockRowInputLabel';
export interface BlockRowInputFieldProps extends React.Props<BlockRowInputField> {
    id: string;
    containerClassName: string;
    errorContainerClassName: string;
    label?: string;
    required?: boolean,
    placeholder?: string;
    tip?: string;
    tipAsHtml?: boolean;
    maxlen?: number;
    readonly?: boolean;
    error?: string;
    value?: string;
    eventMetaData?: any;
    skipInputs?: boolean;
    password?: boolean;

    onValueChanged?: (ev: React.FormEvent<any>, metaData: any) => void;
    onTooltipVisibilityChanged?: (visible: boolean, closeTip: BlockRowInputTooltipDisposer) => void;
}

interface BlockRowInputFieldState {
}

export class BlockRowInputField extends React.Component<BlockRowInputFieldProps, BlockRowInputFieldState> {
    public static ElementId(elementId: string): string {
        return `input-${elementId}`;
    }

    private renderReadonlyTextInput(): JSX.Element {
        return (
            <div className="readonly-input">
                <input key="textinput_hidden"
                    type="hidden"
                    readOnly={true}
                    id={BlockRowInputField.ElementId(this.props.id) }
                    value={this.props.value} />
                <div key="textinput_value" className="readonly-value">{this.props.value || '(empty)'} &nbsp; </div>
            </div>
        );
    }

    private renderTextInput(): JSX.Element {
        if (this.props.skipInputs) {
            return null;
        }
        if (this.props.readonly) {
            return this.renderReadonlyTextInput();
        }

        return (
            <input id={BlockRowInputField.ElementId(this.props.id) }
                onChange={(ev) => this.props.onValueChanged(ev, this.props.eventMetaData) }
                className={this.props.error ? this.props.errorContainerClassName : ''}
                placeholder={this.props.placeholder}
                value={this.props.value}
                type={this.props.password ? "password" : "text"}/>
        );
    }

    private renderError(): JSX.Element {
        if (!this.props.error) {
            return null;
        }

        return (
            <div key="textinput_error" className="error-info">
                {this.props.error}
            </div>
        );
    }

    public render() {
        return (
            <div className={(this.props.containerClassName || '') + ' block-row-input'}>
                <BlockRowInputLabel
                    for={BlockRowInputField.ElementId(this.props.id) }
                    text={this.props.label}
                    tip={this.props.tip}
                    tipAsHtml={this.props.tipAsHtml}
                    required={this.props.required}
                    onTooltipVisibilityChanged={this.props.onTooltipVisibilityChanged} />
                {this.renderTextInput() }
                {this.renderError() }
                {this.props.children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./Client/Views/Shared/BlockRowInputField.tsx